import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./App.css";
import HomePage from "./BasicComponent/Components/homepage";
import SignUp from "./BasicComponent/Components/signUp";
import ForgetPassword from "./BasicComponent/Components/forgetPassword";
import Login from "./BasicComponent/Components/login";
import ResetPassword from "./BasicComponent/Components/ressetPassword";
import PageNotFound from "./BasicComponent/Components/pageNotFound";
import ConfigurationIndex from "./checklistBuilder/module/Configuration/configurationIndex";
import LoginOtp from "./BasicComponent/Components/loginOtp";
import CheckListBuilderRoutes from "./checklistBuilder/utils/checklistBuilderRoutes";
import Dashboard from "./BasicComponent/Components/underConstruction";
import ConfigurationRoutes from "./configuration/Utils/configurationRoutes";
import QualityModuleRoutes from "./QualityModule/utils/qualityModuleRoutes";
import AMSRoutes from "./AssetMonitoringSystem/utils/amsRoutes";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />}>
          <Route path="/" element={<Dashboard />} />
          <Route
            path="check-list-builder/*"
            element={<CheckListBuilderRoutes />}
          />
          <Route path="ams/*" element={<AMSRoutes />} />
          <Route path="quality/*" element={<QualityModuleRoutes />} />
          <Route path="configuration/*" element={<ConfigurationRoutes />} />
        </Route>
        <Route path="/config" element={<ConfigurationIndex />} />
        <Route path="/sign-up" element={<SignUp />} />
        <Route path="/forget-password" element={<ForgetPassword />} />
        <Route path="/login" element={<Login />} />
        <Route path="/login-otp/:email" element={<LoginOtp />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="*" element={<PageNotFound />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
